var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var HeaderGeneratorInteractionModel = require('./headerGeneratorInteractionModel.js');

var HeaderRightAngleGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    HeaderGeneratorInteractionModel.apply(this, arguments);

    this.horizontalTerminalTailLength = this.shadow("horizontalTerminalTailLength",
        function() {
            return this.data.horizontalTerminalTailLength() / this.getUnitFactor();
        },
        function(value) {
            return this.data.horizontalTerminalTailLength(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.horizontalTerminalTailLength, this.userSettingsModel.distanceUnit
        ]
    );

    this.verticalTerminalTailLength = this.shadow("verticalTerminalTailLength",
        function() {
            return this.data.verticalTerminalTailLength() / this.getUnitFactor();
        },
        function(value) {
            return this.data.verticalTerminalTailLength(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.verticalTerminalTailLength, this.userSettingsModel.distanceUnit
        ]
    );
};

lib_core.inherit(HeaderRightAngleGeneratorInteractionModel, HeaderGeneratorInteractionModel);
HeaderRightAngleGeneratorInteractionModel.$class = 'HeaderRightAngleGeneratorInteractionModel';
module.exports = HeaderRightAngleGeneratorInteractionModel;

HeaderRightAngleGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var tailLength1 = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('hTerminalTailLength', 'Horizontal Terminal Tail Length'), true, null, false, this.horizontalTerminalTailLength, this.userSettingsModel.distanceUnit);
    var postLength = PackageGeneratorInspectorConfig.getMinMaxRow('L2', this.LCLZ('terminalPostLength', 'Terminal Post Length'), true, null, false, this.terminalPostLength, this.userSettingsModel.distanceUnit);
    var tailLength2 = PackageGeneratorInspectorConfig.getMinMaxRow('L3', this.LCLZ('vTerminalTailLength', 'Vertical Terminal Tail Length'), true, null, false, this.verticalTerminalTailLength, this.userSettingsModel.distanceUnit);

    return [tailLength1, postLength, tailLength2];
};

HeaderRightAngleGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

HeaderRightAngleGeneratorInteractionModel.prototype.getInspectorElementForBodyHeight = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyHeight', 'Body Height'), false, this.bodyHeightMin, false, this.bodyHeightMax, this.userSettingsModel.distanceUnit)];
};
